<template>
  <div class="container">
    <div class="main">
      <div class="flex-row">
        <h2>Head Office Location and Sales Contact</h2>
      </div>
      <div class="contact-box">
        <div class="box-wrap">
          <img src="@/assets/contact1.png" alt="">
          <div>
            <span>Sales Contact</span>
            <p>Suzie Lee (EU, MENA, APAC)</p>
            <p>Miri Kim (North America)</p>
            <p>Hyungsun Moon (Domestic)</p>
          </div>
        </div>
        <div class="box-wrap">
          <img src="@/assets/contact2.png" alt="">
          <div>
            <span>Phone</span>
            <p>+82 70 4680 2090</p>
          </div>
        </div>
        <div class="box-wrap">
          <img src="@/assets/contact3.png" alt="">
          <div>
            <span>E-mail</span>
            <p>augmentedk@augmentedk.com</p>
          </div>
        </div>
        <div class="box-wrap">
          <img src="@/assets/contact4.png" alt="">
          <div>
            <span>Address</span>
            <p>
              3F, Inha Dream Center,<br />
              100 Inha-ro, Michuhol-gu,<br />
              Incheon, South Korea
            </p>
          </div>
        </div>
      </div>
      <section class="info-sec">
        <div class="user-sec">
          <form>
            <h4>
              HAVE A QUESTION<br />ABOUT AK CONTENT?
            </h4>
            <div class="flex-row flex">
              <div>
                <label>First Name<span class="red">*</span></label>
                <input class="width-100p" type="text" v-model="formData.firstName" placeholder="First Name" />
              </div>
              <div>
                <label>Last Name<span class="red">*</span></label>
                <input class="width-100p" type="text" v-model="formData.lastName" placeholder="Last Name" />
              </div>
            </div>
            <div class="flex-row flex">
              <div>
                <label>Email<span class="red">*</span></label>
                <input class="width-100p" type="text" v-model="formData.email" placeholder="david@blueskyairline.com" />
              </div>
              <div>
                <label style="width: 100%">Phone Number</label>
                <input type="text" v-model="formData.phone" placeholder="Phone Number" />
              </div>
            </div>
            <div class="flex-row flex">
              <div>
                <label>Company Name</label>
                <input class="width-100p" type="text" v-model="formData.company" placeholder="Blue Sky Airlines" />
              </div>
              <div>
                <label>Address</label>
                <input class="width-100p" type="text" v-model="formData.address" placeholder="Address" />
              </div>
            </div>
            <div class="flex-row flex">
              <div>
                <label>City</label>
                <input class="width-100p" type="text" v-model="formData.city" placeholder="City" />
              </div>
              <div>
                <label style="width: 100%">Postal/Zip Code</label>
                <input type="text" v-model="formData.zip" placeholder="Postal/Zip Code" />
              </div>
            </div>
            <div class="flex-row">
              <label>Country</label>
              <input class="width-100p" v-model="formData.country" list="country-list" placeholder="United States" />
              <datalist id="country-list">
                <option v-for="country in countries" :key="country" :value="country" />
              </datalist>
            </div>
            <div class="flex-row">
              <label>Message<span class="red">*</span></label>
              <input class="width-100p" type="text" v-model="formData.message" placeholder="Message" />
            </div>
            <div class="flex-row submit">
              <button @click="submit">Submit</button>
            </div>
          </form>
        </div>
        <div class="aside-right">
          <img src="@/assets/22_Contact.png" alt="">
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactUSPage",
  data() {
    return {
      formData: {
        message: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        company: "",
        address: "",
        country: "",
        city: "",
        zip: "",
      },
      map: null,
      mapCenter: { lat: 37.450354677762, lng: 126.65915614333 },
      // prettier-ignore
      countries: ["Afghanistan", "Aland Islands", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bonaire, Saint Eustatius and Saba ", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "British Virgin Islands", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos Islands", "Colombia", "Comoros", "Cook Islands", "Costa Rica", "Croatia", "Cuba", "Curacao", "Cyprus", "Czech Republic", "Democratic Republic of the Congo", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Ivory Coast", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "North Korea", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestinian Territory", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Republic of the Congo", "Reunion", "Romania", "Russia", "Rwanda", "Saint Barthelemy", "Saint Helena", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Svalbard and Jan Mayen", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "U.S. Virgin Islands", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "United States Minor Outlying Islands", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican", "Venezuela", "Vietnam", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"],
    };
  },
  mounted() {
  },
  methods: {
    async submit(e) {
      e.preventDefault();
      const res = await api.post("/contact", this.formData);

      if (res.status < 300) {
        alert("Form submitted. Thank you for your interest.");
        router.push("/");
      } else {
        alert(res.data);
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  margin: 0 auto;
  padding: 80px 20px;

  .info-sec {
    display: flex;
    gap: 100px;

    .user-sec {
      width: 45%;

      form {

        h4 {
          color: #0F0E4C;
          font-size: 30px;
          font-weight: 700;
          line-height: 40px;
          letter-spacing: -1px;
          margin-block-start: 0;
          margin-block-end: 0;
          margin-inline-start: 0;
          margin-inline-end: 0;
          margin-bottom: 40px;
        }
      }
    }

    .aside-right {
      width: 55%;
    }
  }
}

.contact-box {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 80px;

  .box-wrap {
    border: 1px solid #DDD;
    background: #FFF;
    box-shadow: 2px 2px 15px 0px rgba(0, 0, 0, 0.10);
    padding: 60px;
    text-align: center;

    div {
      margin-top: 20px;

      span {
        font-weight: 700;
        font-size: 18px;
      }

      p {
        margin-top: 5px;
        font-size: 14px;
      }
    }
  }
}

.flex-row {
  width: 100%;
  gap: 10%;

  div {
    width: 45%;
    margin-top: 20px;
  }

  h2 {
    color: #0F0E4C;
    font-size: 40px;
    font-weight: bold;
    letter-spacing: 0;
    margin-bottom: 60px;
  }

  h4 {
    color: #0F0E4C;
    font-size: 30px;
    font-weight: 700;
    line-height: 40px;
    letter-spacing: -1px;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0;
    margin-inline-end: 0;
  }

  .left {
    float: left;
  }

  .right {
    float: right;
    text-align: right;
  }

  label {
    display: block;
    color: #222;
    font-size: 18px;
    font-weight: 500;
  }

  input,
  textarea {
    display: block;
    margin-top: 15px;
    padding: 10px 5px;
    display: block;
    width: 100%;
    font-size: 16px;
    border: none;
    border-bottom: 1px solid #DDD;
  }

  .red {
    color: red;
  }

  .width-100p {
    width: 100%;
  }
}

.submit {
  width: 100%;
  height: 50px;
  padding: 15px 0;
  margin-bottom: 30px;

  button {
    border-radius: 50px;
    border: 1px solid #0F0E4C;
    background: #FFF;
    cursor: pointer;
    width: 100%;
    padding: 15px 0;
    color: #0F0E4C;
    font-weight: bold;
    margin-top: 10px;
  }
}

footer {
  position: absolute;
  bottom: 0;
  text-align: center;
  font-family: sans-serif;
  font-size: 0.8rem;
  font-weight: bold;
  line-height: 0.3rem;
  height: 50px;
}


@media (max-width: 1020px) {
  .flex-row {
    line-height: normal;
  }

  .main {
    padding: 80px 20px;

    div {
      width: 100%;
    }

    .contact-box {
      grid-template-columns: repeat(2, 1fr);

      .main-btn {
        margin-top: 60px;
        padding: 30px 0;
      }
    }
  }

  .info-sec {
    display: block;

    .aside-right {
      visibility: hidden;
    }
  }

}


@media (max-width: 700px) {

  .main {
    padding: 80px 20px;

    div {
      width: 100% !important;
    }

    .contact-box {
      grid-template-columns: repeat(1, 1fr);

      .box-wrap {

        div {

          p {
            position: relative !important;
          }
        }
      }
    }

    .info-sec {
      display: block;

      .aside-right {
        visibility: hidden;
      }
    }
  }
}
</style>
